import { METHOD } from "./method";

export const API_LEAVE_ANALYTICS = {
    LIST: {
        api: '/v1/hr-adm/leave/analytic',
        method: METHOD.POST
    },
    EXPORT: {
        api: '/v1/hr-adm/leave/analytic/export',
        method: METHOD.POST
    },
    LIST_JOB_UNIT: {
        api: '/v1/hr-adm/leave/analytic/job-unit',
        method: METHOD.POST
    },
    COMPANY: {
        api: '/v1/hr-adm/leave/analytic/company',
        method: METHOD.GET
    },
    CATEGORY: {
        api: '/v1/hr-adm/leave/analytic/category',
        method: METHOD.POST
    },
}